import React from 'react';
import { Buttons } from '../buttons';
import css from '../../edit-box-notecard-popup.scss';
export const ConfirmProvideLaterStepComponent = ({
  boxItemsId,
  email,
  onNext,
  onBack
}) => {
  return /*#__PURE__*/React.createElement("div", {
    className: css.confirmStep
  }, /*#__PURE__*/React.createElement("div", {
    className: css.title
  }, "Action Needed!"), /*#__PURE__*/React.createElement("div", {
    className: css.subTitle
  }, "Delays in submitting your notecard design may delay your entire order, so it is important you get it to us as soon as possible. Please send your notecard design to ", /*#__PURE__*/React.createElement("a", {
    href: `mailto:${email}`
  }, email), " as soon as you have it!"), /*#__PURE__*/React.createElement(Buttons, {
    nextText: "Confirm",
    backText: "Go Back",
    onNextButton: () => onNext(boxItemsId),
    onBackButton: onBack
  }));
};